import React from 'react';
import PropTypes from 'prop-types';
import MapEditor from '../../components/MapEditor';
import PageHeader from '../../atoms/PageHeader';

const NewMap = ({ history, match, deployEnv, isFree, isBasic, userControlSetting }) => (
  <>
    <PageHeader>
      <h4>New Map</h4>
    </PageHeader>
    <MapEditor
      history={history}
      match={match}
      deployEnv={deployEnv}
      isFree={isFree}
      isBasic={isBasic}
      userControlSetting={userControlSetting}
    />
  </>
);
NewMap.defaultProps = {};

NewMap.propTypes = {
  history: PropTypes.object.isRequired,
  match: PropTypes.object.isRequired,
  deployEnv: PropTypes.string.isRequired,
  isFree: PropTypes.bool.isRequired,
  isBasic: PropTypes.bool.isRequired,
  userControlSetting: PropTypes.object.isRequired
};

export default NewMap;
